import SeaMarginWrapper from "./components/SeaMarginWrapper"

const settings = {
    routes : [
        {
            path: "/admin/seamargin",
            permissionForPage: "create:seamargin",
            component: SeaMarginWrapper
        },     
    ]
}

export default settings